import React, { memo, useEffect, useMemo, useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu'
import { Avatar, List } from '@mui/material'
import Menu from '@mui/material/Menu'
import Typography from '@mui/material/Typography'
import { Box, Stack } from '@mui/system'
import Image from 'next/image'
import Link from 'next/link'
import Router, { useRouter } from 'next/router'
import { signOut, useSession } from 'next-auth/react'

import { useAppSelector } from '#/app/store/store'
import { getAll, ResponseAllInfo } from '#/entities/user-account/model/user-type-slice'
import { ChatSearch } from '#/features/chat-search'

import { menuListMiddle, menuListTop } from '../../side-menu/ui/side-menu'

import styles from './main-menu-mobile.module.scss'

export const MainMenuMobile = memo(() => {
	const { data, status } = useSession()

	const { pathname, push, asPath } = useRouter()

	const goToMain = async () => {
		await Router.push('/')
	}

	const { profile_picture_link, first_name } = useAppSelector((state) => state.user)

	const [open, setOpen] = React.useState(false)

	const [anchorElNavigate, setAnchorElNavigate] = React.useState<null | HTMLElement>(null)
	const openMenuNavigate = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorElNavigate(event.currentTarget)
	}

	const closeMenuNavigate = () => {
		setAnchorElNavigate(null)
	}

	const [userInfo, setUserInfo] = useState<ResponseAllInfo | null>()

	useEffect(() => {
		getAll(data?.access).then((res) => setUserInfo(res))
	}, [data?.access])

	return (
		<Box>
			<Stack direction='row' spacing={1} alignItems='center' justifyContent='space-between'>
				<Box onClick={(event: any) => setAnchorElNavigate(event.currentTarget)}>
					<MenuIcon
						sx={{
							color: '#868686',
							width: 30,
						}}
					/>
				</Box>
				<Menu
					open={Boolean(anchorElNavigate)}
					onClose={closeMenuNavigate}
					onClick={closeMenuNavigate}
					anchorEl={anchorElNavigate}
					PaperProps={{
						sx: {
							width: '100vw !important',
							zIndex: 1000000000,
							backgroundColor: '#303035',
							position: 'relative',
							overflow: 'visible',
							mt: 1.2,
							borderRadius: '0px 0px 15px 15px',
						},
					}}
				>
					<List sx={{ padding: 0 }}>
						{menuListTop.map((el) => {
							return (
								<MenuItem
									key={el.title}
									open={open}
									pathname={asPath}
									title={el.title}
									link={el.link}
									icon={el.icon}
									activeList={el.activeList}
								/>
							)
						})}
						<Box sx={{ marginTop: 1.5 }}>
							{menuListMiddle.map((el) => {
								return (
									<MenuItem
										key={el.title}
										open={open}
										pathname={asPath}
										title={el.title}
										link={el.link}
										icon={el.icon}
										activeList={el.activeList}
									/>
								)
							})}
						</Box>
					</List>
					<Box sx={{ marginTop: 1.5 }}>
						<Box>
							<MenuItem
								open={open}
								pathname={pathname}
								title={'Поддержка'}
								link={'/reports-mobile'}
								icon={'/svg/side-menu/side-question'}
							/>
						</Box>
						<MenuItem
							open={open}
							pathname={pathname}
							title={'API-ключи'}
							link={'/api-keys'}
							icon={'/svg/side-menu/api-keys'}
						/>
					</Box>
					<Box sx={{ marginTop: 1.5 }}>
						<Box onClick={() => signOut()}>
							<MenuItem open={open} pathname={pathname} title={'Выйти из аккаунта'} link={null} icon={'/logout'} />
						</Box>
						<Link className={styles.requisitesLink} href={'https://air.fail/requisites'}>
							<Typography className='title-main-gray' sx={{ marginLeft: '15px' }}>
								Реквизиты
							</Typography>
						</Link>
					</Box>
				</Menu>
				<Image onClick={goToMain} priority src='/logo.svg' height={26} width={31} alt='Error' />
				<ChatSearch variant='mobile' />
				<Avatar onClick={() => push('/account')} sx={{ width: 29, height: 29 }} src={String(profile_picture_link)}>
					{first_name[0]}
				</Avatar>
			</Stack>
		</Box>
	)
})

MainMenuMobile.displayName = 'MainMenuMobile'

type MenuItemProps = {
	open: boolean
	pathname: string

	title: string
	link: string | null
	icon: string | React.ReactNode
	activeList?: string[]
}

export function MenuItem(props: MenuItemProps) {
	const isActive = useMemo(() => props.link === props.pathname || props.activeList?.some((el) => props.pathname.includes(el)), [props.pathname])

	const content = (
		<Stack sx={{ padding: 1, cursor: 'pointer' }} direction='row' spacing={2}>
			{typeof props.icon == 'string' ? (
				<Image src={props.icon + (isActive ? '' : '-off') + '.svg'} width={19} height={19} alt={''} />
			) : (
				props.icon
			)}
			<Typography className='title-main-gray'>{props.title}</Typography>
		</Stack>
	)

	// Если link null, возвращаем контент без Link
	if (props.link === null) {
		return content
	}

	// Если link есть, оборачиваем в Link
	return <Link href={props.link}>{content}</Link>
}
